export default __webpack_public_path__ + "static/media/slide2.2b9e5f38.jpg";